import {Centre} from "../styled/Center.styled";

function About(props) {
    return <Centre>
    <h1>About Blog</h1>
    <p>To be added soon!!!</p>
</Centre>;
}

export default About;